/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Autosendcertifatesenabled3Inputs */

const en__field_autosendcertifatesenabled3 = /** @type {(inputs: _Field_Autosendcertifatesenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`send certificates automatically`)
};

const de__field_autosendcertifatesenabled3 = /** @type {(inputs: _Field_Autosendcertifatesenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto Zertifikat Versandt aktiviert`)
};

/**
* | output |
* | --- |
* | "send certificates automatically" |
*
* @param {_Field_Autosendcertifatesenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_autosendcertifatesenabled3 = /** @type {((inputs?: _Field_Autosendcertifatesenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Autosendcertifatesenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_autosendcertifatesenabled3(inputs)
	return de__field_autosendcertifatesenabled3(inputs)
});
export { _field_autosendcertifatesenabled3 as "_field_autoSendCertifatesEnabled" }